/* eslint-disable max-len */
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import GlobalContext from '../Context/GlobalContext'
import { motion } from 'framer-motion';

export default function CardHeader({ children, header, path, back, noIcon, activePath }) {
    const { sideBar} = useContext(GlobalContext);
    const navigate = useNavigate()
    return (
        <motion.div
            className={`overflow-x-hidden ${!sideBar ? 'w-customw1' : 'w-customw2'}`}
            animate={{ marginLeft: sideBar ? "70px" : "224px" }}
            transition={{ duration: 0.3 }}
        >
            <div className={`shadow-custom pt-4 pb-4 w-full bg-white h-[110px] fixed z-[99] flex px-[2%] ${path && 'flex-col'}`}>
                <p className="text-[#4B4B4B] font-crimson pb-4">
                    <span className="font-crimson text-sm font-normal text-[#8E8E8E]">
                        {path}
                    </span>
                    {activePath !== undefined &&
                        <span className="font-crimson text-sm font-normal text-[#1F1F1F]">
                            {activePath}
                        </span>}
                </p>
                <div className="flex items-center space-x-[14px] ml-[-6px]">
                    {noIcon === undefined && <img src="/assets/images/chevron-left.svg" data-testid="back-btn" alt="" onClick={() => navigate(back)} />}
                    <h1 className="font-playfair text-[#4B4B4B] text-xl font-[600]">
                        {header}
                    </h1>
                </div>
            </div>


            {children}


        </motion.div>
    )
}
